import { Toaster as Sonner } from "sonner"

const Toaster = ({
  ...props
}) => {

  return (
    (<Sonner
      theme="light"
      visibleToasts={6}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-white group-[.toaster]:text-neutral-950 group-[.toaster]:border-neutral-200 group-[.toaster]:shadow-lg min-h-16 data-[type=success]:!bg-white data-[type=success]:!text-emerald-600 data-[type=success]:!border-emerald-200 data-[type=error]:!bg-white data-[type=error]:!text-red-600 data-[type=error]:!border-red-200",
          description: "group-[.toast]:text-neutral-600 data-[type=success]:!text-emerald-600 data-[type=error]:!text-red-600",
          icon: "scale-125 mr-3 data-[type=success]:!text-emerald-600 data-[type=error]:!text-red-600",
          actionButton:
            "group-[.toast]:bg-neutral-900 group-[.toast]:text-neutral-50",
          cancelButton:
            "group-[.toast]:bg-neutral-100 group-[.toast]:text-neutral-500",
        },
      }}
      {...props} />)
  );
}

export { Toaster }
